import { axios } from '@/utils/request'

const api = {
  prices: '/basicdata/database/list',
  gets:'/basicdata/database/get',
  videoLists:'/basicdata/database/videoList'
}

export function databaseList (parameter) {
  return axios({
    url: api.prices,
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function databaseGet (parameter) {
  return axios({
    url: api.gets,
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function databasevideoList (parameter) {
  return axios({
    url: api.videoLists,
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const brandExport = api.brand + '/export'